module.exports = __webpack_public_path__ + "static/media/shopping-cart.9da4ea69.svg";